import { LazyQueryExecFunction, useLazyQuery } from '@apollo/client';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';

import {
  oAuthProviderConfigurationSchemaQuery,
  OAuthStrategySchemaArg,
  OAuthStrategySchemaField,
  OAuthStrategySchemaResponse,
} from 'apis/partnerIntegrations';

type UseLazyReadOAuthStrategySchemaResponse = {
  oAuthSchema: readonly OAuthStrategySchemaField[];
  isSchemaLoading: boolean;
  isOAuthSchemaError: boolean;
  readOAuthStrategySchema: LazyQueryExecFunction<
    OAuthStrategySchemaResponse,
    OAuthStrategySchemaArg
  >;
  setOAuthSchemaSchema: Dispatch<
    SetStateAction<readonly OAuthStrategySchemaField[]>
  >;
};

/** A hook to retrieve the OAuth strategy schema. */
export const useLazyReadOAuthStrategySchema =
  (): UseLazyReadOAuthStrategySchemaResponse => {
    const [oAuthSchema, setOAuthSchemaSchema] = useState<
      readonly OAuthStrategySchemaField[]
    >([]);

    const [
      readOAuthStrategySchema,
      { data: schemaData, loading: isSchemaLoading, error: oAuthSchemaError },
    ] = useLazyQuery<OAuthStrategySchemaResponse, OAuthStrategySchemaArg>(
      oAuthProviderConfigurationSchemaQuery,
    );

    useEffect(() => {
      if (!isSchemaLoading && schemaData?.Management) {
        setOAuthSchemaSchema(
          schemaData.Management.oAuthProviderConfigurationSchema,
        );
      }
    }, [schemaData, isSchemaLoading]);

    return {
      oAuthSchema,
      isSchemaLoading,
      isOAuthSchemaError: !!oAuthSchemaError,
      readOAuthStrategySchema,
      setOAuthSchemaSchema,
    };
  };
